var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.iconDivClasses},[_c('SvgIcon',{class:_vm.isContentspot ? 'w-6 h-6' : 'w-3 h-5',attrs:{"icon":_vm.iconSlug}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }